<template>

	<component :is="el" >
		<dot-nav v-if="useDotNav" :anchors="anchors" :activeAnchor="activeAnchor" />
		<slot :anchors="anchors" />
	</component>

</template>

<script>

	import Scroller from "./Scroller"
	import DotNav from "./DotNav"
	import _ from 'lodash'
	import $ from 'jquery'

	const AnchorContainer = {
		name: "anchorContainer",
		components: { DotNav },
		props: {
			el: {
				type: String,
				default: "div"
			},
			useDotNav: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				anchors: {},
				activeAnchor: "top",
				lastScrollPos: 0
			}
		},
		provide () {
			return {
				addAnchor: this.addAnchor,
				removeAnchor: this.removeAnchor,
				scrollToAnchor: this.scrollToAnchor
			}
		},
		methods: {
			addAnchor(anchor, anchorContent) {
				this.anchors = {
					...this.anchors,
					...{ [anchor]: anchorContent }
				}
			},
			removeAnchor(anchor) {
				delete this.anchors[anchor]
			},
			scrollToAnchor(anchor) {
				if(anchor === "top") {
					Scroller.scrollToPosition(0)
				}
				else {
					const content = this.anchors[anchor]
					if(content != null) {
						Scroller.scrollToElement(content.$el)
					}
				}
			},
			setActiveAnchor(anchor) {
				this.activeAnchor = (anchor) ? anchor : "top"
			},
			onScroll() {
				const scrollY = window.scrollY;
				const direction = (this.lastScrollPos - scrollY < 0) ? "down" : "up"
				this.lastScrollPos = scrollY
				this.checkActiveAnchor(scrollY, direction)
			},
			checkActiveAnchor(scrollY, direction) {
				if(scrollY === 0) {
					this.setActiveAnchor("top")
					return
				}
				const center = scrollY + $(window).height() / 2
				let measures = _.map(this.anchors, (component, key) => {
					const $el = $(component.$el)
					const top = $el.offset().top
					const bottom = $el.offset().top + $el.height()
					return {
						anchor: key,
						topDist: center - top,
						bottomDist: center - bottom
					}
				})
				if(direction === "down") {
					const passedCenter = _.filter(measures, (d) => d.topDist > 0)
					if(passedCenter == null || passedCenter.length === 0) {
						return
					}
					this.setActiveAnchor(_.minBy(passedCenter, (item) => item.topDist).anchor)
					return
				}
				else if(direction === "up") {
					const passedCenter = _.filter(measures, (d) => d.bottomDist < 0)
					if(passedCenter == null || passedCenter.length === 0) {
						return
					}
					this.setActiveAnchor(_.maxBy(passedCenter, (item) => item.bottomDist).anchor)
					return
				}
			}

		},
		mounted() {
			window.addEventListener("scroll", this.onScroll)
		},
		destroyed() {
			window.removeEventListener("scroll", this.onScroll)
		}
	}

	export default AnchorContainer

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AnchorNav/AnchorContainer.vue